import { BaseIcon } from './base';
import type { IconSmallProps } from './base';

export function IconMessagesSmall(props: IconSmallProps) {
  return (
    <BaseIcon {...props} size={16} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        d="M7.55397 9H12V5H4L4 10.4676L5.49598 9.57003C6.11765 9.19703 6.82899 9 7.55397 9ZM6.52498 11.285C6.83581 11.0985 7.19148 11 7.55397 11H12C13.1046 11 14 10.1046 14 9V5C14 3.89543 13.1046 3 12 3H4C2.89543 3 2 3.89543 2 5V14L6.52498 11.285Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
